<template>
	<div class="fuwu">
		<header-view></header-view>
		<div class="top">Flority Privacy Policy</div>
		<div class="content">Last updated November 5, 2026</div>
		<div class="title">1. Who is responsible</div>
		<div class="content">HEARD (HK) LIMITED operates FLORITY and is responsible for the processing described here. Contact
		jm@heard.ly for privacy questions or requests. This policy covers the FLORITY app and its local browser
		preview.</div>
		<div class="title">2. Data we handle on your device</div>
		<div class="content">FLORITY has no accounts, cloud storage or advertising features, and we do not operate a server that
		receives your work. The app stores your flower choices, layout, vase, background, draft, saved Gallery
		works (including their generated thumbnail images), catalogue scroll positions, preferences and a
		first-launch flag locally on your device or in your browser.<br><br>Recipient names, sender names and
		notes you type into a card are held only in memory while you create it, are drawn into the exported image
		if you choose, and are not stored persistently or sent to us. We do not upload your arrangements, card
		fields or saved images.</div>
		<div class="title">3. Photos and saved images</div>
		<div class="content">When you choose Save Image, the app writes the generated image to your Photos library. On iOS this
		requires a Photos permission prompt, which you can decline or change in iOS Settings; arranging flowers
		works without it, but Save Image will then be unavailable. FLORITY does not open, read, scan or upload
		your existing photo library.<br><br>Exported images contain any names and note you entered. Once an image
		is saved to Photos or downloaded in the browser preview, it is outside FLORITY’s local Gallery and is
		handled by Apple, your browser or any service you choose to open it with, under their own policies.</div>
		<div class="title">4. Technical and diagnostic information</div>
		<div class="content">To keep FLORITY working reliably, limited technical and diagnostic information may be processed by the
		app runtime and the operating system, such as device and app version, network status, and crash or error
		reports. This information is used for troubleshooting and reliability only, is handled under the
		applicable platform or service provider’s privacy practices, and is kept no longer than necessary. It
		does not include your arrangements, card text or photo library, and is not used for advertising,
		profiling or tracking.<br><br>Apple may also receive crash, diagnostic and usage information from your
		device if you have enabled sharing with app developers in iOS Settings; Apple handles that data under
		Apple’s Privacy Policy. You can change that choice in iOS Settings.</div>
		<div class="title">5. Retention and deletion</div>
		<div class="content">Local drafts, Gallery works and preferences remain until the app or its local data is removed. Removing
		the iOS app or clearing the browser’s FLORITY site data removes its local store; export works first.
		Delete saved Photos images separately in Photos. Card message fields are not written to persistent
		storage and are cleared when the app restarts.<br><br>If you email us, we use your address and the
		contents of your message to answer your request and keep them only as needed for support and legal
		obligations. Technical and diagnostic information handled by the operating system or service providers
		follows their own retention practices and is not something we can delete on their behalf. We have no
		server copy of your artwork and cannot recover it.</div>
		<div class="title">6. Your choices and rights</div>
		<div class="content">You can skip card message fields, decline Photos access, choose whether to save an image, and limit
		diagnostic sharing in iOS Settings. Depending on your location, you may have rights to access, correct,
		delete or receive your personal data, object to or restrict processing, withdraw consent, and complain to
		a data-protection authority. Email jm@heard.ly; we will verify requests proportionately and respond
		within applicable legal deadlines. Exercising these rights will not result in discriminatory treatment.</div>
		<div class="title">7. Children, security and changes</div>
		<div class="content">FLORITY is not directed to children under 14, and we do not knowingly collect their personal information.
		The app offers no accounts or user profiles. Contact us if you believe a child has sent us personal
		information.<br><br>We use reasonable safeguards and limit processing to the purposes described here, but
		no system is completely secure. We update this policy when practices change, show the updated date and
		provide any notice or consent required by law.</div>
		<div class="title">Useful links</div>
		<div class="content">
			<li><a href="https://www.apple.com/legal/privacy/" target="_blank" rel="noopener">Apple Privacy Policy</a></li>
		</div>
		<div class="title">Contact</div>
		<div class="content">HEARD (HK) LIMITED<br>jm@heard.ly</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		methods: {},
		mounted() {

		}
	}
</script>

<style lang="less" scoped>
	.fuwu {
		padding: 87px 15px 40px;

		.top {
			font-size: 28px;
			font-weight: 600;
			padding: 25px 0;
		}

		.title {
			font-size: 20px;
			margin: 20px 0;
		}

		.content {
			font-size: 13px;

			li {
				margin: 10px 0;
			}

			a {
				color: inherit;
				text-decoration: underline;
			}
		}
	}
</style>
